/**
 * 日期相关过滤器
 */

import { formatDate } from '@/utils/date'

/**
 * 格式化日期 月-日（12-01）
 */
export function dateMD(value) {
  return formatDate(value, 'MM-DD')
}

/**
 * 格式化日期 年-月-日（2018-12-01）
 */
export function dateYMD(value) {
  return formatDate(value, 'YYYY-MM-DD')
}

/**
 * 格式化日期 年-月-日（2018年12月01日）
 */
export function dateCnYMD(value) {
  return formatDate(value, 'YYYY年MM月DD日')
}

/**
 * 格式化日期 时:分:秒（09:32:03）
 */
export function dateHMS(value) {
  return formatDate(value, 'HH:mm:ss')
}
/**
 * 格式化日期 年-月-日 时:分（2018-12-01 09:32）
 */
export function dateYMDHM(value) {
  return formatDate(value, 'YYYY-MM-DD HH:mm')
}

/**
 * 格式化日期 年-月-日 时:分:秒（2018-12-01 09:32:03）
 */
export function dateYMDHMS(value) {
  return formatDate(value)
}
